import { GET_ZONE, GET_AREA, GET_FACILITY_TYPE } from "../constants/type";
import Immutable from 'immutable';

const initStatus = {
    areas: [],
    zones: [],
    types: []
};

export default function constantReducer(state = initStatus, action = {}) {
    switch (action.type) {
    case GET_ZONE+"_FULFILLED":
        if( action.payload.status > 300 ){
            return state;
        }
        return Immutable.fromJS(state)
            .updateIn(["zones"], v => action.payload.data )
            .toJS();

    case GET_AREA+"_FULFILLED":
        if( action.payload.status > 300 ){
            return state;
        }
        return Immutable.fromJS(state)
            .updateIn(["areas"], v => action.payload.data )
            .toJS();

    case GET_FACILITY_TYPE+"_FULFILLED":
        if( action.payload.status > 300 ){
            return state;
        }
        return Immutable.fromJS(state)
            .updateIn(["types"], v => action.payload.data )
            .toJS();


    default:
        return state
    }
}